import { Doc } from "yjs";
import { WebrtcProvider } from "y-webrtc";
import * as awarenessProtocol from "y-protocols/awareness";
import { useEffect, useState } from "react";

const doc = new Doc();

export interface User {
  username: string;
  color: string;
  isCurrentUser: boolean;
}

export const useYDoc = (ulid?: string, username?: string, color?: string) => {
  const [activeUsers, setActiveUsers] = useState<User[]>([]);

  if (ulid == null) {
    return {
      activeUsers,
    };
  }

  useEffect(() => {
    let provider: WebrtcProvider | undefined = undefined;

    try {
      provider = new WebrtcProvider(ulid, doc, {
        signaling: ["wss://connections.dev.webb.party/ywrtc"],
        awareness: new awarenessProtocol.Awareness(doc),
        maxConns: 20 + Math.floor(Math.random() * 15),
        filterBcConns: true,
        peerOpts: {},
      });

      const { awareness } = provider;

      awareness.on("change", () => {
        setActiveUsers(
          Array.from(awareness.getStates()).map(([_, state]) => ({
            username: state.user.name,
            color: state.user.color,
            isCurrentUser: state.user.name === username,
          }))
        );
      });

      awareness.setLocalStateField("user", { name: username, color });
    } catch (error) {
      console.error(error);
    }

    return () => {
      provider?.destroy();
    };
  }, []);

  return {
    activeUsers,
  };
};
